import { back } from "../Api/ApiUrl";
import instance from "../Api/Instance";
import { storeArq } from "correos-arq-utils";
import { useDispatch } from "react-redux";
import { updateUserProfiles } from "../redux/slices/UserProfilesSlice";

export default function useProfiles() {
  const dispatch = useDispatch();
  async function getUserProfiles(userDetails) {
    dispatch(updateUserProfiles({ data: [], isLoading: true }));

    try {
      const response = await instance.get(back.getUserProfiles);

      if (response.status === 200) {
        dispatch(
          updateUserProfiles({ data: response?.data, isLoading: false })
        );
      }

      if (response.status !== 200) {
        dispatch(updateUserProfiles({ data: [], isLoading: false }));
      }
      
    } catch (error) {
      dispatch(updateUserProfiles({ data: [], isLoading: false }));
      console.error(error);
    }
  }
  return { getUserProfiles };
}
